<template>
  <div class="wrapper">
    <div
      v-for="(item, index) in itemsToShow"
      @click="itemClicked(item, $event)"
      :id="'item_box_' + item.id"
      :key="item.id + '-' + index"
      :style="{
        animationDelay: delay[index]
      }"
      class="itemBox"
      :class="{
        animate: animate,
        bigBox: isBigBox(item) && isHightlightItem(item),
        soldout: item.soldout,
        active: activeItem && activeItem.id === item.id,
        'itemBox-isWide': isWide
      }"
    >
      <product-attribute-icons-overlay
        :product="item"
        :showInfoIcon="showInfoIcon"
        @onConfirmProductAttributes="confirmProductAttributes"
      />
      <img
        v-if="isWide && big && item.wide_image"
        class="itemImg"
        :src="item.wide_image"
      />
      <img
        v-else-if="big && item.highlight_image && isHightlightProduct(item)"
        class="itemImg"
        :src="item.highlight_image"
      />
      <img v-else class="itemImg" :src="imageSource(item)" />
      <div
        class="itemName text"
        :class="{ 'itemName-isWide': isWide, 'text-isWide': isWide }"
      >
        {{ itemDisplayName(item) }}
      </div>
      <div class="itemPrice" :class="{ 'itemPrice-isWide': isWide }">
        {{ itemPrice(item) }}
      </div>
      <div class="whiteBg" :class="{ 'whiteBg-isWide': isWide }"></div>
    </div>
  </div>
</template>
<script>
import ProductAttributeIconsOverlay from "@/components/common/ProductAttributeIconsOverlay.vue";
import { getTranslation } from "@/utils/helpers";
import { checkSchedule } from "@/utils/schedules";
import { mapGetters } from "vuex";
import {
  extraListItemPrice,
  productListItemPrice,
  sizeListItemPrice
} from "@/utils/pricing";

export default {
  components: { ProductAttributeIconsOverlay },
  props: {
    itemType: {
      type: String,
      default: "product"
    },
    activeItem: Object,
    activeCombo: Object,
    itemsToShow: Array,
    delay: {
      type: Array,
      default: () => []
    },
    menuOffset: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: true
    },
    big: {
      type: Boolean,
      default: false
    },
    bigItem: {
      type: Boolean,
      default: false
    },
    showInfoIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    imageSource(item) {
      if (this.itemType === "size") {
        return item.alternate_picture;
      } else {
        return item.image;
      }
    },
    isHightlightProduct(item) {
      if (item.id !== this.currentCategory.highlight_product) return false;

      return (
        this.currentCategory.highlight_product_schedules.length === 0 ||
        this.currentCategory.highlight_product_schedules.some(schedule =>
          checkSchedule(this.schedules, schedule)
        )
      );
    },
    confirmProductAttributes(item) {
      this.$emit("onConfirmProductAttributes", item);
    },
    itemClicked(item) {
      this.$emit("onItemClicked", item);
    },
    itemDisplayName(item) {
      let typeKlassMap = {
        product: "Product",
        extra: "Extra",
        size: "Size"
      };
      return getTranslation(
        this.$store,
        typeKlassMap[this.itemType],
        "display_name",
        item.id,
        item.name
      );
    },
    itemPrice(item) {
      if (this.itemType === "product") {
        return productListItemPrice(item, this.menuOffset, this.activeCombo);
      } else if (this.itemType === "extra") {
        return extraListItemPrice(item);
      } else if (this.itemType === "size") {
        return sizeListItemPrice(item, this.menuOffset, this.activeItem);
      } else {
        return "";
      }
    },
    getTranslation,
    isBigBox(item) {
      return (
        !this.isWide &&
        this.bigItem &&
        this.currentCategory &&
        item.id === this.currentCategory.highlight_product
      );
    },
    isHightlightItem(item) {
      if (item.id !== this.currentCategory.highlight_product) return false;

      const scheduleState =
        this.currentCategory.highlight_product_schedules.length === 0 ||
        this.currentCategory.highlight_product_schedules.some(schedule =>
          checkSchedule(this.schedules, schedule)
        );

      return scheduleState;
    }
  },
  computed: {
    ...mapGetters({
      currentCategory: "CURRENT_CATEGORY"
    }),
    onMenuPage() {
      return this.$route.name === "menu";
    },
    isWide() {
      return this.onMenuPage && this.currentCategory.list_layout === 1;
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes itemBoxIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.wrapper {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: min-content;
  grid-auto-flow: dense;
  gap: 20px;
}

.ScanAndGoProductContainer .wrapper {
  display: block;
  padding: 8px;
}

.itemBox {
  width: 100%;
  text-align: center;
  opacity: 1;
  transform: scale(1);
  display: flex;
  flex-direction: column;
  align-items: start;
}

.itemBox.bigBox {
  grid-column-end: span 2;
  grid-row-end: span 2;
}

.itemBox img {
  width: 100%;
  height: 133px;
  object-fit: contain;
}

.itemBox.bigBox img {
  width: 100%;
  height: 319px;
  object-fit: cover;
  margin: var(--component_common_ItemList_itemBox_bigBox_margin);
  border-top-left-radius: var(
    --component_common_ItemList_whiteBg_border-radius
  );
  border-top-right-radius: var(
    --component_common_ItemList_whiteBg_border-radius
  );
}

div.itemName,
div.itemPrice {
  padding-inline: var(--component_common_ItemList_padding-left);
}

.itemName {
  flex-grow: 1;
  display: flex;
  align-items: var(--component_common_ItemList_itemName_align-vertical);
}

.bigBox .itemName {
  align-items: flex-end;
}

.whiteBg {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: -1;
}

.itemBox.active .whiteBg {
  background-color: var(
    --component_common_ItemList_itemBox_active_whiteBg_background-color
  );
  border: var(--component_common_ItemList_itemBox_active_whiteBg_border);
}

.itemBox.active .itemPrice {
  color: #fff;
}

.soldout .itemImg {
  opacity: 0.12;
}

.soldout .itemPrice {
  font-family: var(--component_common_ItemList_soldout_itemPrice_font-family);
  text-transform: lowercase;
  font-size: 14px;
  margin-top: 0px;
}

.itemBox.animate {
  transform: scale(0);
  opacity: 0;
  animation: itemBoxIn 500ms forwards ease;
}

.main_menu_product_list .itemBox-isWide {
  grid-column-end: span 3;
}

.itemName {
  font-size: 17px;
  letter-spacing: var(--app_letter-spacing_dense);
  font-family: var(--app_font-family_regular);
  color: var(--component_common_ItemList_color);
  font-weight: normal;
  text-transform: var(--component_common_ItemList_text-transform);
  text-align: var(--component_common_ItemList_text-align);
  padding-left: var(--component_common_ItemList_padding-left);
}

.itemName-isWide {
  color: var(--component_common_ItemList_itemName-isWide_color);
  text-transform: var(
    --component_common_ItemList_itemName-isWide_text-transform
  );
}

.itemPrice {
  letter-spacing: 0;
  color: var(--component_common_ItemList_itemPrice_color);
  font-family: var(--component_common_ItemList_itemPrice_font-family);
  font-size: var(--component_common_ItemList_itemPrice_font-size);
  margin: var(--component_common_ItemList_itemPrice_margin);
  height: 20px;
  text-align: var(--component_common_ItemList_itemPrice_text-align);
  padding-left: var(--component_common_ItemList_itemPrice_padding-left);
}

.itemPrice-isWide {
  color: var(--component_common_ItemList_itemPrice-isWide_color);
  font-family: var(--component_common_ItemList_itemPrice-isWide_font-family);
  font-size: var(--component_common_ItemList_itemPrice-isWide_font-size);
}

.whiteBg {
  width: 100%;
  height: calc(100% - 77px);
  background: var(--component_common_ItemList_whiteBg_background);
  border-radius: var(--component_common_ItemList_whiteBg_border-radius);
  box-shadow: var(--component_common_ItemList_whiteBg_box-shadow);
  margin-top: -115px;
}

.whiteBg-isWide {
  background: var(--component_common_ItemList_whiteBg-isWide_background);
}

.gradient {
  transition: opacity 0.5s ease;
  z-index: 5;
  position: absolute;
  pointer-events: none;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gradient.top {
  top: -3px;
  background: var(--component_SliderTabs_top_gradient_background);
}

.gradient.bottom {
  bottom: -3px;
  background: var(--component_SliderTabs_bottom_gradient_background);
}

.text {
  color: var(--component_common_ItemList_color);
  font-family: var(--component_common_ItemList_font-family);
  font-size: var(--component_common_ItemList_font-size);
  font-style: normal;
}

.text-isWide {
  color: var(--component_common_ItemList_text-isWide_color);
  font-family: var(--component_common_ItemList_text-isWide_font-family);
  font-size: var(--component_common_ItemList_text-isWide_font-size);
  font-style: normal;
}
</style>
